import { themeColors } from "../../../themeColors";
/**
 * @file   src\mobile\components\SendIntroduction\IntroEditPhotos.js
 * @brief  This file is responsible for showing editing inventory photos
 * @date   May, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useState, useEffect } from "react";
import "../../styles/clients.scss";
import { getUserType, setLocalStorage } from "../../../helpers/common";
import {
  AGENT_INTRODUCTION,
  MEMBER_INTRODUCTION,
} from "../../../constants/common";

import {
  DndContext,
  closestCenter,
  MouseSensor,
  TouchSensor,
  DragOverlay,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { SortableContext, rectSortingStrategy } from "@dnd-kit/sortable";
import { SortablePhoto } from "./SortablePhoto";
import TopHeader from "../common/TopHeader";
import { usePremium } from "@/hooks";
import BackLinkButton from "../../components/BackLinkButton";
import { Photo } from "./Photo";
import { CUSTOMIZE_INTRO } from "../../../constants/onBoarding";

const IntroEditPhotos = (props) => {
  const [activeId, setActiveId] = useState(null);
  const sensors = useSensors(useSensor(MouseSensor), useSensor(TouchSensor));

  const { shouldToggleColor } = usePremium();

  useEffect(() => {
    document.body.classList.add("bg-offcanvas-fix");
  }, []);

  const userType = getUserType();

  let session = userType == 2 ? AGENT_INTRODUCTION : MEMBER_INTRODUCTION;

  const { selectedProperty } = props;
  const [selectedDatas, setSelectedDatas] = useState(selectedProperty);
  const inventoryPhotosForPreview = selectedProperty?.photosForPreview;
  const [inventoryPhotos, setInventoryPhotos] = useState([]);

  useEffect(() => {
    if (inventoryPhotosForPreview && inventoryPhotosForPreview.length > 0) {
      setInventoryPhotos(inventoryPhotosForPreview);
    } else {
      setInventoryPhotos([]);
    }
  }, [inventoryPhotosForPreview]);

  useEffect(() => {
    setLocalStorage(session, selectedDatas);
  }, [selectedDatas]);

  function handleDragStart(event) {
    setActiveId(event.active.id);
  }
  /**
   * To handle drag and drop of images
   * @param {*} event
   */
  function handleDragEnd(event) {
    const { active, over } = event;
    let sourceIndex = active.data?.current?.sortable?.index;
    let destinationIndex = over.data?.current?.sortable?.index;
    if (sourceIndex !== destinationIndex) {
      let newInventoryPhotos = inventoryPhotos;
      newInventoryPhotos.splice(
        destinationIndex,
        0,
        newInventoryPhotos.splice(sourceIndex, 1),
      );

      newInventoryPhotos = newInventoryPhotos.map((item) =>
        Array.isArray(item) ? item[0] : item,
      );
      newInventoryPhotos = newInventoryPhotos.map((feature, index) => {
        return { ...feature, order: index + 1, isCover: index > 2 ? 0 : 1 };
      });

      let orderdImages = newInventoryPhotos.sort((a, b) => a.order - b.order);
      setInventoryPhotos(orderdImages);

      let newArray = { photosForPreview: orderdImages };

      setSelectedDatas((selectedDatas) => ({ ...selectedDatas, ...newArray }));
    }

    setActiveId(null);
  }

  function handleDragCancel() {
    setActiveId(null);
  }

  return (
    <div className="gitcha-main-wrapper my-client-wrap">
      <div className="content-wrapper content-wrapper-h-102-percent">
        <TopHeader
          variant={"review"}
          outerClassname="bg-white"
          topClassName="header-brdr-btm w-100"
          bottomClassName="signup-header-txt clearfix"
        >
          <BackLinkButton
            shouldToggleColor={shouldToggleColor}
            variant="small"
            onClick={() => props.setUIKey(CUSTOMIZE_INTRO)}
          />
          <span className={shouldToggleColor ? "heading-premium" : "heading"}>
            Edit Photos
          </span>
        </TopHeader>
        <div className="inner-layout-content-new bg-white">
          <div className="reorder-wrap">
            <h4>Drag to change your photos for this introduction</h4>
            <p className="m-0">
              You can show up to three photos in your introduction. They will be
              able to see all photos when they accept.{" "}
            </p>

            <section className="uploaded-file-list-mob w-100 position-relative">
              <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragStart={handleDragStart}
                onDragEnd={handleDragEnd}
                onDragCancel={handleDragCancel}
              >
                <SortableContext
                  items={inventoryPhotos}
                  strategy={rectSortingStrategy}
                >
                  {inventoryPhotos
                    .sort((a, b) => a.order - b.order)
                    .map((photo, index) => {
                      return (
                        <SortablePhoto key={index} url={photo} index={index} />
                      );
                    })}
                </SortableContext>

                <DragOverlay adjustScale={true}>{null}</DragOverlay>
              </DndContext>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroEditPhotos;
